<template>
  <template v-if="address.title == 'COMPANY'">
    <div><CheckoutTitleTranslate :title="address.title" /> {{ address.company }}</div>
    <div>{{ address.firstName }} {{ address.lastName }}</div>
  </template>
  <template v-else>
    <div><CheckoutTitleTranslate :title="address.title" /> {{ address.firstName }} {{ address.lastName }}</div>
  </template>
  <div>{{ address.street }} {{ address.houseNumber }}</div>
  <div>{{ address.zip }} {{ address.city }}</div>
  <div>{{ address.email }}</div>
  <div>{{ address.telephone }}</div>
</template>

<script setup lang="ts">
defineProps({
  address: {
    type: Object,
    required: true,
  },
});
</script>
